import useUserPlatform from './useUserPlatform'

export default useUserPlatform
